import { Menu, Pill, TextButton } from "@amzn/storm-ui";
import styled from "styled-components";

export const VerticalLine = styled.div`
    height: 32px;
    border-left: 1px solid ${({ theme }) => theme.color.gray[200]};
    margin: 0 4px;
`;

export const FilterContainer = styled.div`
    position: sticky;
    top: 0px;
    padding: 16px 24px;
    margin-left: -24px;
    margin-right: -24px;
    background-color: ${({ theme }) => theme.color.gray[0]};
    border-bottom: 1px solid ${({ theme }) => theme.color.gray[200]};
    z-index: 2;
`;

export const StyledPill = styled(Pill)`
    cursor: pointer;
    &:hover {
        box-shadow: none;
    }
`;

export const StyledMenu = styled(Menu)`
    overflow-y: auto;
    max-height: 40vh;
`;

export const StyledSelectAllTextButton = styled(TextButton)`
    padding: 1px 11px 0px;
    height: 26px;
`;

export const StyledClearAllTextButton = styled(TextButton)`
    padding: 1px 11px 0px;
    height: 26px;
`;

export const StyledFilterActionsContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const StyledLinkBox = styled.div`
    border-radius: 8px;
    box-sizing: border-box;
    padding-block: 3px;
    padding-inline: 11px;
`;
